// extracted by mini-css-extract-plugin
export default {"actionButtonStyle":"ChangeContactNameCard_actionButtonStyle__XEEuY","form":"ChangeContactNameCard_form__o7EFd","gridContainer":"ChangeContactNameCard_gridContainer__vFn5-"};